// UI strings for the User Guide search, What's New and "Need Help?", copied
// verbatim from Claude Design CMP Dashboard (19). The design line is noted on
// each string; change them only when the design changes. Guide and What's New
// text itself is served by the backend, not held here.

export const GUIDE_SEARCH_STRINGS = {
  // guide-search.js:130
  searching: "Searching the User Guide…",
  // guide-search.js:148 — "N match(es) in M guide page(s). Select a result to open the page at that section."
  summary: (total: number, pages: number) =>
    `${total} match${total === 1 ? "" : "es"} in ${pages} guide page${pages === 1 ? "" : "s"}. Select a result to open the page at that section.`,
  // guide-search.js:144
  moreOnPage: (count: number) => `${count} more on this page`,
  // guide-search.js:192-193
  barSearch: "Search: ",
  barCount: (current: number, total: number) => `${current} of ${total}`,
  previousMatch: "Previous match",
  nextMatch: "Next match",
  clearSearch: "Clear search",
  // Not in the design (helper text wave 3): the search request did not run,
  // so the design "No matches" text would be wrong.
  searchFailed:
    "We could not search the User Guide. Check your internet connection and try again.",
} as const;

export const WHATS_NEW_STRINGS = {
  // CMP Dashboard.dc.html:18492 — 'Back to ' + WN_DATA[key].name + ' Page'
  back: (name: string) => `Back to ${name} Page`,
  // :188
  previousUpdates: "Previous What's New Updates",
  // :189
  backToLatest: "Back to Latest What's New",
  // :190
  print: "Print",
  // :194
  pill: "WHAT'S NEW",
  // :18493 — 'As of ' + Month D, YYYY
  asOf: (dateLabel: string) => `As of ${dateLabel}`,
  // :194
  previousHeading: "Previous Updates",
  // :195
  currentLead: "Updates made to this section since the previous update.",
  // :195
  previousLead: "Earlier updates to this section, for reference only.",
  // :200
  noPrevious: "There are no previous What's New updates for this section yet.",
} as const;

export const SIDEBAR_UPDATE_STRINGS = {
  // CMP Dashboard.dc.html:86 (module header pill) and :86 title attribute
  updated: "Updated",
  moduleTitle: "This module has updates",
  // :90 (sub item dot title)
  dotTitle: "Updated",
  // :93 (Calculators)
  newPill: "New",
} as const;

export const NEED_HELP = {
  // CMP Dashboard.dc.html:170-173
  href: "https://chamberperksapp.freshdesk.com/support/tickets/new",
  title: "Need Help?",
  subtitle: "Create a ticket from here",
} as const;

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

/** "2026-10-15" -> "October 15, 2026" (design: toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })). */
export const formatDesignDate = (isoDate: string): string => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate);
  if (!match) return "";
  return `${MONTHS[Number(match[2]) - 1]} ${Number(match[3])}, ${match[1]}`;
};
